import React, { useRef, useEffect, useState } from "react";

import { useContext } from "react";
import { EnteredContext } from "../context/EnteredContext";

export default function Snack(props) {
  const canvasRef = useRef(null);
  const ctxRef = useRef(null);
  const imageRef = useRef(new Image());

  const [isFall, setIsFall] = useState(false);
  const { entered } = useContext(EnteredContext);

  useEffect(() => {
    const canvas = canvasRef.current;
    ctxRef.current = canvas.getContext("2d");
    imageRef.current.src = props.image;
    imageRef.current.onload = () => {
      ctxRef.current.drawImage(
        imageRef.current, // image of spritesheet
        0,
        0, // cut from spritesheet
        props.itemW,
        props.itemH, // sw, sh (size of sprite)
        props.x,
        props.y, // dx, dy
        props.itemW,
        props.itemH, // dw, dh (size on canvas)
      );
    };
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    ctxRef.current = canvas.getContext("2d");
    imageRef.current.src = props.image;

    let currentFrame = 0;
    let gravity = 0.3;
    let velocity = 0; // Local variable to handle velocity
    let yPosition = props.y; // Initialize yPosition locally

    const triggerFall = () => {
      ctxRef.current.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas
      setIsFall(true);

      ctxRef.current.drawImage(
        imageRef.current, // image of spritesheet
        0,
        0, // sx, sy (cut from spritesheet)
        props.itemW,
        props.itemH, // sw, sh (size of sprite)
        props.x,
        yPosition, // dx, dy
        props.itemW,
        props.itemH, // dw, dh (size on canvas)
      );

      ctxRef.current.drawImage(
        imageRef.current, // image of spritesheet
        0,
        0, // cut from spritesheet
        props.itemW,
        props.itemH, // sw, sh (size of sprite)
        props.x,
        props.y, // dx, dy
        props.itemW,
        props.itemH, // dw, dh (size on canvas)
      );

      currentFrame++;

      // Update velocity and yPosition
      velocity += gravity;
      yPosition += velocity;

      if (currentFrame < 50) {
        requestAnimationFrame(triggerFall);
      }
    };

    if (entered === props.trigger) {
      triggerFall();
      setIsFall(false);
    }
  }, [entered]);

  return (
    <div className={props.css} style={{ zIndex: isFall ? 30 : 20 }}>
      <canvas
        ref={canvasRef}
        width={props.width}
        height={props.height}
      ></canvas>
    </div>
  );
}
